import { CheckSquare } from 'lucide-react';
import { sortBySortOrder } from '@/utils/sort';
import type { SurveyQuestionDetail } from '../../types/survey.types';
import { EmptyOptionsNote } from './EmptyOptionsNote';

interface SurveyDropdownPreviewProps {
  question: SurveyQuestionDetail;
}

export function SurveyDropdownPreview({ question }: SurveyDropdownPreviewProps) {
  const sortedOptions = sortBySortOrder(question.options);

  if (sortedOptions.length === 0) return <EmptyOptionsNote />;

  return (
    <div className="space-y-2">
      <p className="text-xs font-medium text-muted-foreground">Options:</p>
      <ul className="space-y-1.5 rounded-md border bg-card p-2">
        {sortedOptions.map((option) => (
          <li key={option.id} className="flex min-w-0 items-center gap-2 px-2 py-1 text-sm">
            <CheckSquare className="size-3.5 shrink-0 text-muted-foreground/70" />
            <span className="min-w-0 wrap-break-word">{option.text}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
